import axios from 'axios';

export default {
  getThemes({ commit, getters }, formId) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${formId}/themes`)
        .then((response) => {
          commit('setThemesList', response.data.data);
          commit('setPreviewTheme', getters.getSelectedTheme);
          return resolve(response.data.data);
        })
        .catch((error) => reject(error));
    });
  },

  storeTheme({ commit }, { theme, formId }) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${formId}/themes`, theme)
        .then((response) => {
          commit('setThemesList', response.data.data);
          return resolve(response.data.data);
        })
        .catch((error) => reject(error.response));
    });
  },

  updateTheme({ commit }, { theme, formId }) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.put(`/ajax/web-forms/events/${formId}/themes/${theme.id}`, theme)
        .then((response) => {
          commit('setThemesList', response.data.data);
          return resolve(response.data.data);
        })
        .catch((error) => reject(error.response));
    });
  },

  duplicateTheme({ commit }, { themeId, formId }) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${formId}/themes/${themeId}`)
        .then((response) => {
          commit('setThemesList', response.data.data);
          return resolve(response.data.data);
        })
        .catch((error) => reject(error.response.data));
    });
  },

  destroyTheme({ commit }, { formId, theme }) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.delete(`/ajax/web-forms/events/${formId}/themes/${theme.id}`, theme)
        .then((response) => {
          commit('setThemesList', response.data.data);
          return resolve(response.data.data);
        })
        .catch((error) => reject(error.response.data));
    });
  },

  updateSelectedTheme({ commit }, { formId, themeId }) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.put(`/ajax/web-forms/events/${formId}/themes/assignThemeToForm/${themeId}`)
        .then((response) => {
          commit('setThemesList', response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => reject(error.response.data));
    });
  },

  getFormsByThemeId({ commit }, { themeId, formId }) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${themeId}/themes/showRelatedForms/${formId}`)
        .then((response) => {
          commit('setRelatedForms', response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => reject(error.response.data));
    });
  },
};
